$(document).ready(function () {
    let geotargetingBlock = $("#geo-targeting-block");

    if (geotargetingBlock.length > 0)
    {
        let contentGuid = $("#geo-targeting-block").attr("data-geo-block-guid");
        $.ajax({
            url: "/DefaultPage/LoadContentIfLocationMatch",
            type: "GET",
            data : {contentGuid : contentGuid},
            success: function (response) {
                $("#geo-targeting-block").html(response);
            },
            error: function (response) {
                console.log("ajax request failed for geotargeting block");
            }
        });
    }
});
